// 单选
<template>
  <div id="MyTransfer">
    <div class="filter-dash-btn" @click="handleClick">
      <div class="filter-checked-app" v-if="isCheckId">
        <div class="checked-app-item">
          <span>{{selectShow_name}}</span>
        </div>
        <i
          @click.stop="handleClear"
          class="el-icon-circle-close checked-clear anticon anticon-close-circle"
        ></i>
      </div>
      <div class="filter-tips-default" v-else>点击选择人员</div>
    </div>
    <el-dialog
      :append-to-body="true"
      title="请选人员"
      :visible.sync="selectDia"
      width="50%"
      :before-close="handleClose"
      @close="handleClosed"
    >
      <div class="container">
        <div class="left">
          <div class="leftHead">
            <i class="el-icon-search"></i>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
          </div>
          <div class="leftBody">
            <el-tree :data="userList" ref="tree" :filter-node-method="filterNode1">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-radio
                  v-if="node.data.is_department=='0'"
                  v-model="isCheckId"
                  @change="handleCbChange(node)"
                  :label="node.data.id"
                >{{ node.data.show_name }}</el-radio>
                <span v-else>{{ node.data.show_name }}</span>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectDia = false">取 消</el-button>
        <el-button type="primary" @click="getCheckedNodes">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectShow_name: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      isCheckId: '',
      activeNameSelectPeople: 'first',
      filterText: '',
      defaultArr: [],
      selectTree: [],
      selectArr: [],
      selectData: {},
      selectDia: false,
      memberPeople: [],
      userList: [],

      defaultProps: {
        children: 'children',
        label: 'label',
      },
    }
  },
  props: ['selectedId', 'selectedName'],
  mounted() {
    this.isCheckId = this.selectedId
    this.selectShow_name = this.selectedName
    console.log('mountedselectedName', this.selectedName)
  },
  activated() {
    this.isCheckId = this.selectedId
    this.selectShow_name = this.selectedName
    console.log('activated selectedName', this.selectedName)
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    selectedId(val, oldVal) {
      //普通的watch监听
      this.isCheckId = val
      if (val) {
        this.isCheckId = val
      }
    },
    selectedName(val, oldVal) {
      this.selectShow_name = val
      //普通的watch监听
    },
  },
  methods: {
    // ***获取人员列表
    async getUserListWith() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/simple_member',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.userList = res.datas.listInfo
      console.log('选择成员列表', this.userList)
    },
    handleCbChange(node) {
      this.selectShow_name = node.data.show_name
      this.$emit('my-one-change', this.isCheckId, this.selectShow_name)
    },
    lableChange(val) {
      this.isCheckId = val
      console.log(this.isCheckId)
    },
    filterNode(value, data) {
      console.log('value', value)
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    filterNode1(value, data) {
      console.log('value', value)
      if (!value) return true
      return data.show_name.indexOf(value) !== -1
    },
    handleClear() {
      this.isCheckId = ''
      this.$emit('my-one-change', this.isCheckId, '')
    },
    // 点击确定按钮
    getCheckedNodes() {
      this.labelName = this.isCheckId
      // this.$emit('my-one-change', this.isCheckId)
      this.$emit('my-one-change', this.isCheckId, this.selectShow_name)
      this.selectDia = false
    },
    handleClick() {
      this.selectDia = true
    },
    handleClose() {
      this.selectDia = false
    },
    handleClosed() {
      this.filterText = ''
    },
  },
  created: function () {
    this.isCheckId = this.selectedId
    this.selectShow_name = this.selectedName
    console.log('created selectedName', this.selectedName)
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    this.getUserListWith()
  },
}
</script>
<style lang="less" scoped>
#MyTransfer {
  display: flex;
  align-items: center;
}
#MyTransfer {
  font-size: 14px;
}
#MyTransfer .filter-item-name {
  margin-right: 15px;
  text-align: right;
}
#MyTransfer .filter-item-wrapper {
  display: flex;
  align-items: center;
}
#MyTransfer .filter-dash-btn {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 234px;
  width: 100%;
  height: 40px;
  // border-radius: 4px;
  border: 1px solid #c9ccd8;
  color: #c9ccd8;
  cursor: pointer;
  transition: all 0.3s;
}
#MyTransfer .filter-item-wrapper .filter-dash-btn:hover {
  border: 1px dashed #107fff;
}
#MyTransfer .filter-tips-default {
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-left: 15px;
  align-items: center;
  width: 100%;
  height: 32px;
  transition: all 0.3s;
}
#MyTransfer .filter-item-wrapper .filter-dash-btn:hover .filter-tips-default {
  color: #107fff;
}
.filter-checked-app {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  padding: 4px;
}
.checked-app-item {
  padding: 2px 6px;
  margin: 0 4px 0 0;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
}
.checked-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #ccc;
  transition: color 0.2s;
}
.checked-clear:hover {
  color: #aaa;
}

// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}
/deep/ .el-dialog__header {
  padding: 16px 24px;
  color: #304265;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  .el-dialog__title {
    margin: 0;
    color: #304265;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
}
/deep/.el-dialog__body {
  padding: 0;
  font-size: 14px;
  line-height: 1.5;
  .container {
    width: 100%;
    display: flex;
    padding: 0 20px;
    box-sizing: border-box;
    .left {
      width: 100%;
      border-right: 1px solid #e8e8e8;
      box-sizing: border-box;
      .leftHead {
        display: flex;
        align-items: center;
        padding: 12px 24px;
        border-bottom: 1px solid #e8e8e8;
        i {
          color: #aaa;
        }
        // (deep)
        .el-input__inner {
          height: 22px;
          border: none;
          padding-left: 10px;
        }
      }
      .leftBody {
        box-sizing: border-box;
        padding-left: 10px;
        padding-top: 10px;
        height: 344px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
    .right {
      box-sizing: border-box;
      padding: 16px;
      width: 45%;
      height: 390px;
      overflow-x: hidden;
      overflow-y: scroll;
      .h3-organization-selected {
        position: relative;
        display: inline-block;
        background: #fafafa;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        padding: 0 24px 0 26px;
        margin: 0 8px 8px 0;
        height: 22px;
        max-width: 100%;
        .el-icon-user {
          left: 8px;
          margin-right: 6px;
          font-size: 12px;
          color: #bfbfbf;
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
        }
        .el-icon-close {
          color: #bfbfbf;
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
          width: 10px;
          height: 10px;
          font-size: 10px;
          margin-left: 8px;
          right: 8px;
        }
        .h3-organization-selected-name {
          display: inline-block;
          height: 100%;
          line-height: 1.5;
          max-width: 215px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
/deep/ .el-dialog__footer {
  padding: 10px 16px;
  text-align: right;
  .el-button {
    height: 32px;
    padding: 0 15px;
  }
}
// 修改弹窗样式
/deep/.el-tabs {
  width: 100%;
}
</style>